<template>
    <a 
        class="exhibitor-file"
        :href="file.url"
        target="_blank"
    >
        <ResourceFileIcon  :fileName="file.file_real_name" :url="file.url" />
        <div class="exhibitor-file__info">
            <p class="exhibitor-file__info-name mb-1">
                {{ file.file_real_name }}
            </p>
            <p class="exhibitor-file__info-data mb-0">
                {{ fileDate }}
            </p>
        </div>
    </a>
</template>
<script>
import ResourceFileIcon from '@/components/Resource/ResourceFileIcon'
export default {
    components: {
        ResourceFileIcon
    },
    props: {
        file: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        fileDate() {
            const date = new Date(this.file.time * 1000);
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            return date.toLocaleDateString('en-US', options);
        }
    }
}
</script>
<style lang="scss">
.exhibitor-file {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    padding: 16px;
    border: 1px solid #E2E2E2;
    background-color: #F3F3F6;
    border-radius: 12px;
    margin-bottom: 12px;
    text-decoration: none;
    
    &__info {
        margin-left: 8px;
    
        &-name {
            color: var(--accent-color);
            font-size: 16px;
            font-weight: 700;
            line-height: 19.5px;
            text-decoration: underline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-word;
        }
    
        &-data {
            color: #9B9B9B;
            font-size: 13px;
            font-weight: 500;
            line-height: 19.37px;
        }
    }
    
    .file-format-icon {
        mix-blend-mode: multiply;
    }
}
</style>